import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useDataContext } from "../Context/dataContext";
import { FaLock } from "react-icons/fa";

function AdmRe() {
  const { setAccessToken, url } = useDataContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const fetchData = async (email, password) => {
    try {
      const response = await axios.get(
        `${url}/Auth/loginAdmin/${email}/${password}`
      );
      if (response.data.success !== true) {
        setError(response.data.message || "Error al iniciar sesión");
      } else {
        setError("");
        setAccessToken(response.data.data);
        history.push("/Dashboard");
      }
    } catch (error) {
      setError(error.response?.data?.message || "Error al iniciar sesión");
      await axios.get(`${url}/Auth/logoutAdmin/${email}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const loginSuccessful = await fetchData(email, password);

    if (loginSuccessful) {
      return;
    }
  };

  return (
    <div className="admin-login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-icon">
            <FaLock />
          </div>
          <h2>Acceso Administrativo</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                placeholder="Correo electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {error && <p className="error">{error}</p>}
            <button type="submit" disabled={loading}>
              {loading ? "Accediendo..." : "Iniciar sesión"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export { AdmRe };
